import { gql } from '@apollo/client';

export const QUERY_OPDS_ACCOUNT_BY_PAGE = gql`
  query QueryOpdsAccountByPage(
    $condition: OpdsAccountQueryConditionInput
    $pageRequest: PageRequestTypeInput
  ) {
    queryOpdsAccountByPage(condition: $condition, pageRequest: $pageRequest) {
      content {
        id
        email
        countryCode
        phone
        name
        roleNames
        language
        status
        blacklist
        phoneStatus
        employed
        createdAt
        updatedAt
        deptIds
        roleIds
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export interface OpdsAccountType {
  id: number | string;
  email?: string | null;
  countryCode?: number | null;
  phone?: number | string | null;
  name?: string | null;
  roleNames?: string[] | null;
  language?: string | null;
  status?: number | null;
  blacklist?: boolean | null;
  phoneStatus?: number | null;
  employed?: boolean | null;
  createdAt?: number | null;
  updatedAt?: number | null;
  deptIds?: number[];
  roleIds?: number[];
  larkId?: string | null;
}

export interface OpdsAccountQueryConditionInput {
  id?: number | null;
  name?: string | null;
  phone?: string | null;
  status?: number | null;
}

export interface PageRequestTypeInput {
  page?: number;
  size?: number;
  sortBy?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export interface OpdsAccountPageResponseType {
  content: OpdsAccountType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface QueryOpdsAccountByPageResponse {
  queryOpdsAccountByPage: OpdsAccountPageResponseType;
}

export interface QueryOpdsAccountByPageVariables {
  condition?: OpdsAccountQueryConditionInput | null;
  pageRequest?: PageRequestTypeInput | null;
}
